// easter egg 

let delay; // Create variable for setTimeout
let longpress = 250; // Set number of milliseconds for longpress
let i = 0;

let imageLoveOn = false; // statut image hover
let imageLove = document.querySelector("#imageLove"); // imageLove Element


const postLike = () => {

    document.querySelectorAll('.interaction__love__action').forEach(item => {

        // One Like click ajax
        item.addEventListener('click', e => {
            e.preventDefault();
            if(i == 0) {
                i++;
                let post_likes = Number(item.querySelector("span").getAttribute('data-likes'));
                post_likes++;
                item.querySelector("span").textContent = post_likes;
                item.querySelector("span").setAttribute('data-likes', post_likes);
            }
            ajaxSaveLikes(item, i);
        });


        /*
         * Easter
         */

        // Works like press
        item.addEventListener('mousedown', e => {
            e.preventDefault();
            likesAction(item);
        }, true);
        item.addEventListener('touchstart', e => {
            e.preventDefault();

            // first like
            if(i == 0) {
                i++;
                let post_likes = Number(item.querySelector("span").getAttribute('data-likes'));
                post_likes++;
                item.querySelector("span").textContent = post_likes;
                item.querySelector("span").setAttribute('data-likes', post_likes);
            }
            ajaxSaveLikes(item, i);

            likesAction(item);
        }, true);

        // when you leave mouse press
        item.addEventListener('mouseup', function (e) {
            e.preventDefault();
            clearTimeout(delay);
            clearLike(item);
        });
        item.addEventListener('touchend', function (e) {
            e.preventDefault();
            clearTimeout(delay);
            clearLike(item);

            ajaxSaveLikes(item, i);
        });
        item.addEventListener('mouseout', function (e) {
            e.preventDefault();
            clearTimeout(delay);
            clearLike(item);
        });

    });


}

export default postLike;

// clear like effects
function clearLike(item) {

    let loveIcon = item.querySelector(".icon .icon-love");
    let bretzelIcon = item.querySelector(".icon .icon-bretzel");
    let cathedraleIcon = item.querySelector(".icon .icon-cathedrale");

    loveIcon.classList.remove("d-none");
    bretzelIcon.classList.add("d-none");
    cathedraleIcon.classList.add("d-none");

    if(imageLoveOn == true && imageLove.style.width != "100vw" ){
        imageLove.src = '';
        imageLove.style.display = "none";
        imageLove.style.width = 0;
        imageLoveOn = false;
    }
}

// like easter action
function likesAction(item) {


    let result = item.querySelector("span");
    let loveIcon = item.querySelector(".icon .icon-love");
    let bretzelIcon = item.querySelector(".icon .icon-bretzel");
    let cathedraleIcon = item.querySelector(".icon .icon-cathedrale");
    let animation = item.querySelector('.icon');

    let widthImg = 10;
    let likes = Number(result.getAttribute('data-likes'));

    let cathedraleIconOn = false;
    let bretzelIconOn = false;

    i = 0;
    delay = setInterval(check, longpress);

    function check() {
        i++;
        result.textContent = likes + i;

        // Exponentielle ++
        if( i > 6 && i < 65 ) {
            i++;
            result.textContent = likes + i;
        }
        if( i > 20 && i < 65 ) {
            i++;
            result.textContent = likes + i;
        }
        if( i > 40 && i < 65 ) {
            i++;
            result.textContent = likes + i;
        }
        if( i > 60 && i < 65 ) {
            i++;
            result.textContent = likes + i;
        }
        if( i > 6 && i < 65 ) {
            animation.classList.toggle('on');
        }
        // end - Exponentielle ++


        // Change icon to bretzel
        if( i > 21 && bretzelIconOn == false ){
            widthImg = 10;
            loveIcon.classList.add("d-none");
            bretzelIcon.classList.remove("d-none");
            bretzelIconOn = true;
        }

        // Change icon to cathedrale
        if( i > 41 && cathedraleIconOn == false ){
            bretzelIcon.classList.add("d-none");
            cathedraleIcon.classList.remove("d-none");
            cathedraleIconOn = true;
        }

        // Show Image
        if( i > 61 && imageLoveOn == false){
            imageLoveOn = true;
        }

        // Change size Image
        if( imageLoveOn == true && widthImg != 0 ) {
            if(imageLove.style.width != "100vw" ) {
                imageLove.style.display = "block";
                imageLove.style.width = widthImg + "vw";
                widthImg = widthImg + 45;
            }else{
                imageLove.style.display = "none";
                imageLove.style.width = "0vw";
                widthImg = 0;
            }
        }

        let dataLikes = likes + i;
        result.setAttribute('data-likes', dataLikes);

    }

}

// ajax save like
function ajaxSaveLikes(item, i) {

    // Get Data
    let post_id = item.getAttribute('data-post-id');
    let nonce = item.getAttribute('data-nonce');
    let post_likes = Number(item.querySelector("span").getAttribute('data-likes'));

    // Save Likes
    let xhttp = new XMLHttpRequest();

    // Response
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            document.querySelectorAll(".interaction__love__action").forEach(love__action => {
                love__action.querySelector("span").textContent = post_likes;
                love__action.classList.add("active");
            });
        }
    };

    // action
    xhttp.open("POST", pokaa.ajaxurl, true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("action=save_element_likes&element_id=" + post_id + "&element_likes=" + i
        + "&nonce=" + nonce );

}